export class USA {
  selection?:
    | "Any"
    | "None"
    | "US Regions"
    | "In-State"
    | "Out-of-State"
    | "Specific States/Territories";
  value?: any[];

  constructor(
    selection?:
      | "Any"
      | "None"
      | "US Regions"
      | "In-State"
      | "Out-of-State"
      | "Specific States/Territories",
    value?: string[]
  ) {
    this.selection = selection || "Any";
    this.value = value || [];
  }
}

export class International {
  selection?: "Any" | "None" | "Specific Countries";
  value?: any[];

  constructor(
    selection?: "Any" | "None" | "Specific Countries",
    value?: string[]
  ) {
    this.selection = selection || "Any";
    this.value = value || [];
  }
}

export class GeographyReducerState {
  usa: USA;
  international: International;

  constructor(usa?: USA, international?: International) {
    this.usa = usa || new USA();
    this.international = international || new International();
  }
}
